import { render, staticRenderFns } from "./TblReadingView.vue?vue&type=template&id=2833b8f7&scoped=true"
import script from "./TblReadingView.vue?vue&type=script&lang=js"
export * from "./TblReadingView.vue?vue&type=script&lang=js"
import style0 from "./TblReadingView.vue?vue&type=style&index=0&id=2833b8f7&prod&scoped=true&lang=css"
import style1 from "./TblReadingView.vue?vue&type=style&index=1&id=2833b8f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2833b8f7",
  null
  
)

export default component.exports